import auth from './auth'
import user from './user'
import layout from './layout'

export default {
  auth,
  user,
  layout
}
